/**
 * Get the product price out of the price_information object
 * @param {object} price_information - object containing all the product price info
 * @return {string}
 */
export default function getProductPrice(price_information) {
    return price_information.estimated_piece_price || price_information.price;
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/get-product-price.js